let source
function getPort() {
  if (typeof process !== "undefined" && process.env && process.env.WEBPACKER_DEV_SERVER_PORT) {
    return process.env.WEBPACKER_DEV_SERVER_PORT
  }
  return 3038
}
function establishEventSource() {
  if (source) {
    source.close()
  }

  const port = getPort()
  source = new EventSource(`http://localhost:${port}/hot-reload`)

  source.onopen = (_event) => {
    console.log("Connected to bun live reload server")
  }

  source.onmessage = (event) => {
    const data = JSON.parse(event.data)
    if (data.type === "rebuild") {
      console.log("Rebuild detected, reloading page...")
      window.location.reload()
    }
  }

  source.onerror = (_event) => {
    console.error("Error connecting to bun live reload server. Make sure it's running with --watch option.")
    source.close()
  }
}

if (process.env.NODE_ENV === "development") {
  establishEventSource()
}

// Reconnect on page visibility change (e.g., when switching tabs)
document.addEventListener("visibilitychange", () => {
  if (document.visibilityState === "visible" && process.env.NODE_ENV === "development") {
    establishEventSource()
  }
})
